import { mapValues } from 'lodash';
/**
 * Version 21 migrations: Add maxNumberOfRequests and set it to 1
 */
export default function v21(website) {
  return {
    ...website,
    eventVersion: 21,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'HotelRequest' && layoutItem.config.hotelSetupSettings
      && !layoutItem.config.hotelSetupSettings.maxNumberOfRequests) {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            hotelSetupSettings: {
              ...layoutItem.config.hotelSetupSettings,
              maxNumberOfRequests: 1
            }
          }
        };
      }
      return layoutItem;
    })
  };
}
